let appState = {
  appName: "Bookkerry",
  isAuthenticated: false,
  isAdmin: false,
  isAdminPush: false,
};


export default appState;



// WEBPACK FOOTER //
// ./src/helpers/AppState.js